import React from 'react';

//PACKS
import { connect } from 'react-redux';
import { Button, Alert, Navbar, Spinner } from 'react-bootstrap';
import { withRouter } from 'react-router-dom';
import { Form as FinalForm } from 'react-final-form';
import { UserPin } from '@styled-icons/boxicons-regular/UserPin'

//Containers
import NovaSenha from './NovaSenha';

//Components
import FormValidarCodigo from '../../../components/forms/logins/FormValidarCodigo';

//ACTIONS
import { pesquisacodigo } from '../../../actions/login/login';
import { pesquisa as pesquisageren } from '../../../actions/logingerenciamento/login';

//TOOLS
import { getTraducaoTrocaPor as trad } from '../../../utils/getTraducoes';

class ValidarCodigo extends React.Component {

    state = {
        novasenha: false,
        resultCodigo: null
    }
    
    onSubmit = async (form) => {
        let dados = {};
        let forms = {};
        switch (this.props.idcategoria) {
            case 3://Gerenciamento
                dados = await this.props.pesquisageren(form);
                dados = {
                    ...dados,
                    result: dados[0]&&dados[0].id?true:false
                }
                console.log(dados);
                break;
        
            default://Credenciamento
                forms = {
                    idpromotora: this.props.idpromotora,
                    ...form
                }
                dados = await this.props.pesquisacodigo(forms);        
                break;
        }

        this.setState({
            resultCodigo: dados.result
        })
        
        if(dados&&dados.result===true){
            setTimeout(() => {
                this.setState({
                    novasenha: !this.state.novasenha?true:false
                });
                this.form.reset();
            },5000)
        }
    }

    render(){

        if(!Object.keys(this.props.trads).length){
            return null;
        }
        
        if(this.state.novasenha){
            return (
                <NovaSenha {...this.props} />
            );
        }
        
        return (
            <FinalForm 
            onSubmit={this.onSubmit}
            validate={ values => {
                const errors = {};
                if(!values.codigo){
                    errors.codigo = trad(this.props.trads,'ERROEMAIL1',this.props.lingua);
                }
                
                return errors;
            }}
            render={({form, pristine, submitting, handleSubmit}) => {
                this.form = form;
                return (
                <form onSubmit={handleSubmit}>
                    <Navbar bg="light" expand="lg" className="justify-content-center">
                        <Navbar.Brand>{trad(this.props.trads,'Informe o código recebido por E-mail',this.props.lingua)}</Navbar.Brand>
                        <UserPin size="60" />
                    </Navbar>
                    {                    
                    this.state.resultCodigo===false?
                    <Alert variant="warning">Código não encontrado!</Alert>
                    :
                    this.state.resultCodigo===true?
                    <Alert variant="success">Código validado com sucesso!</Alert>
                    :
                    null
                    }
                    <FormValidarCodigo 
                    form={form}
                    {...this.props}                    
                    />
                    <Button          
                        id="btosubmit"               
                        variant="primary" 
                        size="lg" 
                        block 
                        type="submit"       
                        onClick={this.handleSubmitLog}
                        disabled={submitting || pristine}
                        >
                        {this.props.pendingTasks?
                        <Spinner animation="border"  />
                        :
                        trad(this.props.trads,'BT_AVANCAR2',this.props.lingua)
                        }
                    </Button>
                    <Button
                        variant="secondary" 
                        size="lg" 
                        block 
                        type="button"       
                        onClick={this.props.handleVoltar}                        
                        >
                        {trad(this.props.trads,'Voltar',this.props.lingua)}
                    </Button>
                </form>
                )
            }}
            />
        )
    }
}

const mapStateToProps = (state) => {
    return {
        trads: state.reducerTraducoes,
        pendingTasks: state.pendingTasks        
    }
}

export default connect(mapStateToProps,{pesquisacodigo,pesquisageren})(withRouter(ValidarCodigo));